import logoLightBlue from "../../images/mykyc-logo-blue-800px.png";
import "./css/TopBand.css";

export default function TopBand({
  title,
  titleIcon,
  titleIconAlt = "",
  logoSrc = logoLightBlue,
  subtitle,
  right,
  contentClassName = "",
  smallBandColor = "#f7e9d0",
  titleColor = "#7f848b",
}) {
  return (
    <div className="topBandRow">
      <div className={`topBandContent ${contentClassName} topBandContainer`}>
        <img
          src={logoSrc}
          alt=""
          className="topBandLogo"
          draggable="false"
        />
        <div className="topBandSmall" style={{ "--top-band-small-bg": smallBandColor }}>
          <div className="topBandHeader d-flex align-items-center justify-content-between">
            <div>
              <h2 className="topBandTitle m-0" style={{ color: titleColor }}>
                {titleIcon ? (
                  <span className="topBandTitleWithIcon">
                    <img
                      src={titleIcon}
                      alt={titleIconAlt}
                      className="topBandTitleIcon"
                      aria-hidden={titleIconAlt ? undefined : "true"}
                    />
                    <span>{title}</span>
                  </span>
                ) : (
                  title
                )}
              </h2>
              {subtitle ? <div className="topBandSubtitle">{subtitle}</div> : null}
            </div>

            {right ? <div className="topBandActions">{right}</div> : null}
          </div>
        </div>
      </div>
    </div>
  );
}
